import React, { FunctionComponent, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { Input, InputOnChange, InputOnFocus } from '@afterpaytouch/core'
import { MoneyFieldSchema } from '../../types'
import { useError, useVisible } from '../../utils/hooks'

export const MoneyField: FunctionComponent<MoneyFieldSchema> = ({ name = '', props, options, show = true, testNameSpace = '', currencySymbol }) => {
  const { register, setValue } = useFormContext()
  const { isVisible, values } = useVisible({ name, show })
  const { isError, errorText } = useError({ name, error: props?.error })
  const [rawValue, setRawValue] = useState<string>('')
  const component = register(name, {
    ...options,
    value: values ?? props?.value,
    ...(typeof props?.onBlur !== 'undefined' && { onBlur: props?.onBlur }),
  })

  const onBlurHandler = (ev: InputOnFocus): void => {
    setValue(name, rawValue, {
      shouldValidate: true,
      shouldDirty: true,
      shouldTouch: true,
    })
  }

  const onChangeHandler = (e: InputOnChange, rawValue: string): void => {
    const nanFallback = !isNaN(parseFloat(rawValue)) ? parseFloat(rawValue).toString() : '0'
    const parsedValue = rawValue.trim().length === 0 ? '' : nanFallback

    setRawValue(parsedValue)
    setValue(name, parsedValue, {
      shouldValidate: true,
      shouldDirty: true,
      shouldTouch: true,
    })
  }
  return isVisible ? (
    <Input.Tel
      {...component}
      {...props}
      format={`${currencySymbol ?? '$'} [00000{0.00}]`}
      onBlur={onBlurHandler}
      testNameSpace={testNameSpace}
      error={isError}
      errorText={errorText}
      onChange={onChangeHandler}
      ref={component.ref}
      fullWidth
    />
  ) : null
}
